/**
 * Helper function for validating that object has keys
 * @param {object} test
 * * @param {array} testAgainst
 */
export function validate(test, testAgainst) {
  let errors = {};
  testAgainst.forEach(key => {
    if (!test.hasOwnProperty(key) || test[key].length === 0) {
      errors[key] = [norm(key) + ' is required!'];
    }
  })

  return errors;
}

export function norm(str) {
  if (str.includes('_')) {
    str = str.split('_');
    return str[0].charAt(0).toUpperCase() + str[0].slice(1) + ' ' + str[1].charAt(0).toUpperCase() + str[1].slice(1);
  } else {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}


// WEBPACK FOOTER //
// ./src/helpers/validate.js